export default [
  '$q',
  '$http',
  '$window',
  ($q, $http, $window) => {
    const getWindowData = () => ({
      ua: $window.navigator.userAgent,
      width: $window.innerWidth,
      height: $window.innerHeight,
      url: $window.location.href,
    });

    const sendRequest = (data, source) => {
      const requestData = {
        ...getWindowData(),
        source,
        ...data,
      };

      const deferred = $q.defer();

      $http({
        method: 'POST',
        url: '/ajax/feedback',
        headers: { 'Content-Type': 'application/json' },
        data: requestData,
        allowServerErrors: true,
      })
        .then(successResponse => {
          if (successResponse.data.status === 'ok') {
            deferred.resolve(successResponse);
          } else {
            deferred.reject(successResponse);
          }
        })
        .catch(errorResponse => {
          deferred.reject(errorResponse);
        });

      return deferred.promise;
    };

    return {
      // Попап Сообщить о проблеме
      sendError: data => {
        return sendRequest(data, 'addform_error');
      },
      // Попап Что вы думаете о новой форме
      sendFeedback: data => {
        return sendRequest(data, 'addform_success');
      },
      // Попап Проблема с вводом адреса
      sendAddressProblem: data => {
        return sendRequest(data, 'addstep1geo');
      },
    };
  },
];
